var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient, computedFrom } from "aurelia-framework";
import { BaseChooseTickets } from "../../base-choose-tickets";
import { BrandingBase } from "../../../../../views/app/admin/branding/branding-base";
import { ClientLotteryClientService } from "../../../../../services/modules/client/client-lottery-client-service";
import { GamePlayerTicketClientService } from "../../../../../services/modules/client/client-game-player-ticket-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import moment from 'moment';
import { FormatterHelper } from "../../../../../helpers/numbers-helper";
import * as Enumerable from "linq";
import { MobileHelper } from "../../../../../helpers/mobile-helper";
var ChooseTickets = /** @class */ (function (_super) {
    __extends(ChooseTickets, _super);
    function ChooseTickets(router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) {
        return _super.call(this, router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) || this;
    }
    ChooseTickets.prototype.getTicketsPerLine = function () {
        return 4;
    };
    Object.defineProperty(ChooseTickets.prototype, "date", {
        get: function () {
            if (!this.lottery) {
                return "";
            }
            var drawTime = moment.utc(this.lottery.drawDate, "YYYY-MM-DD HH:mm");
            var local = drawTime.local();
            //set draw time to lottery draw date
            var dateWithDrawTime = new Date(this.lottery.drawDate);
            if (local) {
                dateWithDrawTime.setHours(local.hours());
                dateWithDrawTime.setMinutes(local.minutes());
            }
            var milliseconds = new Date(dateWithDrawTime).getTime() - new Date().getTime();
            var seconds = Math.floor((milliseconds / 1000) % 60);
            var minutes = Math.floor((milliseconds / 1000 / 60) % 60);
            var hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
            var days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
            if (days < 0) {
                //when date is smaller then 0 ex -0.5 we need to do math.ceil otherwise it will change it to -1 and a day still has not passed
                days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
            }
            var str = '';
            if (days)
                str += "".concat(days, "days");
            if (hours || days)
                str += " ".concat(hours, "hrs");
            if (minutes || hours || days)
                str += " ".concat(minutes, "mins");
            return str;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChooseTickets.prototype, "prize", {
        get: function () {
            if (this.lottery) {
                return FormatterHelper.getformattedValue(this.lottery.totalJackpot, navigator.language, 2);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    ChooseTickets.prototype.showStep1 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-1-quick-pick",
                "step-1-pick-all",
                "step-1-pick",
                "step-1-numbers",
                "step-1-add-lines",
                "step-1-remove-lines",
                "completed",
                //Colors
                "header-lottery-background",
                "header-lottery-title-foreground",
                "header-lottery-title-border",
                "header-lottery-prize-foreground",
                "header-lottery-prize-border",
                "header-lottery-next-draw-foreground",
                "quick-pick-background",
                "quick-pick-hover-background",
                "quick-pick-foreground",
                "quick-pick-hover-foreground",
                "quick-pick-icon-erase-foreground",
                "choose-tickets-border",
                "ticket-background",
                "ticket-border",
                "ticket-pick-numbers-background",
                "ticket-pick-numbers-foreground",
                "ticket-pick-random-background",
                "ticket-pick-random-hover-background",
                "ticket-pick-random-foreground",
                "ticket-pick-random-hover-foreground",
                "ticket-erase-background",
                "ticket-erase-hover-background",
                "ticket-erase-foreground",
                "ticket-erase-hover-foreground",
                "ticket-main-number-background",
                "ticket-main-number-selected-background",
                "ticket-main-number-selected-foreground",
                "ticket-main-number-border",
                "ticket-bonus-background",
                "ticket-bonus-pick-numbers-background",
                "ticket-bonus-pick-numbers-foreground",
                "ticket-bonus-number-background",
                "ticket-bonus-number-selected-background",
                "ticket-bonus-number-selected-foreground",
                "ticket-bonus-number-border",
            ]
        }, window.parent.location.origin);
    };
    ChooseTickets.prototype.showStep2 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-2-best-value",
                "step-2-remember-to-play",
                "step-2-subscribe-today",
                "step-2-subscribe-tooltip",
                "step-2-increase-your-chances-subscribe-to",
                "step-2-draw",
                "step-2-draws",
                "step-2-line",
                "step-2-line",
                //Colors
                "draw-background",
                "draw-foreground",
                "draw-border",
                "draw-background-hover",
                "draw-background-selected",
                "draw-best-value--background",
                "draw-best-value--foreground",
                "draw-check-box-border",
                "draw-check-box-background",
                "draw-check-box-selected-border",
                "draw-check-box-selected-background",
                "draw-check-box-tick-background",
                "draw-price-was-foreground",
                "draw-price-now-foreground",
            ]
        }, window.parent.location.origin);
    };
    ChooseTickets.prototype.showStep3 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-3-draw",
                "step-3-draws",
                "step-3-draw",
                "step-3-lines",
                "step-3-discount",
                "step-3-total",
                "step-3-add-to-cart",
                "step-3-get-tickets",
                "step-3-get-tickets",
                "step-3-loading",
                "step-3-login-message",
                "step-3-update",
                "update-cart",
                "tickets-confirmed",
                "tickets-added-to-cart",
                "no-tickets-to-add-to-cart",
                "failed-to-purchase-tickets",
                "no-tickets-to-purchase",
                "select-draw-number",
                "prices-not-set-for-your-currency",
                "no-draws-set-up",
                "purchased-tickets-successfully-message",
                "purchased-tickets-successfully-title",
                "updated-cart-notification-title",
                "updated-cart-notification-message",
                "please-select-all-numbers",
                "dialog-confirm-message",
                "dialog-cancel-button",
                "dialog-confirm-button",
                "not-authenticated-message",
                "add-to-cart-not-logged-in-notification-message",
                //Colors
                "purchase-tickets-tickets-foreground",
                "purchase-tickets-discount-foreground",
                "purchase-tickets-total-border",
                "purchase-tickets-total-foreground",
                "purchase-tickets-button-add-to-cart-background",
                "purchase-tickets-button-add-to-cart-hover-background",
                "purchase-tickets-button-add-to-cart-foreground",
                "purchase-tickets-button-add-to-cart-hover-foreground",
                "purchase-tickets-button-get-tickets-background",
                "purchase-tickets-button-get-tickets-hover-background",
                "purchase-tickets-button-get-tickets-foreground",
                "purchase-tickets-button-get-tickets-hover-foreground",
                "purchase-tickets-login-message-background",
                "purchase-tickets-login-message-foreground",
                "choose-tickets-update-cart-button-background",
                "choose-tickets-update-cart-button-hover-background",
                "choose-tickets-update-cart-button-foreground",
                "choose-tickets-update-cart-button-hover-foreground",
            ]
        }, window.parent.location.origin);
    };
    ChooseTickets.prototype.showMobileTickets = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "mobile-tickets-button-add",
                //Colors
                "mobile-ticket-line-background",
                "mobile-ticket-line-num-background",
                "mobile-ticket-line-num-foreground",
                "mobile-ticket-line-num-bonus-background",
                "mobile-ticket-line-num-bonus-foreground",
                "mobile-ticket-add-line-background",
                "mobile-ticket-add-line-foreground"
            ]
        }, window.parent.location.origin);
    };
    ChooseTickets.prototype.onLotteryDetailsLoaded = function () {
        var _this = this;
        var tickets = Enumerable.from(this.tickets)
            .count(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; });
        if (MobileHelper.isMobileDevice() && !this.cartGuid && tickets == 0) {
            this.pickOne();
            this.pickOne();
            this.pickOne();
            this.pickOne();
        }
    };
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ChooseTickets.prototype, "date", null);
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ChooseTickets.prototype, "prize", null);
    ChooseTickets = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, TokenClient, GamePlayerTicketClientService, BindingSignaler,
            NotificationClientService, I18N, ClientLotteryClientService, EventAggregator,
            DialogClientService, Element])
    ], ChooseTickets);
    return ChooseTickets;
}(BaseChooseTickets));
export { ChooseTickets };
